import DefaultFormButton from './DefaultFormButton';
import TiFormButton from './TiFormButton';
import generateRender from 'shared/utils/generateRender';

const FormButton = generateRender({
  default: DefaultFormButton,
  ti: TiFormButton
})

export default FormButton;